import { Directive } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

import { ISPFieldConfig } from '../model/field-config.interface';
import { ISPFieldType } from '../model/field-type.enum';
import { ISPFormOptions } from '../model/form-options.interface';
import { ISPFormState } from '../model/form-state.interface';

/**
 * Field wrapper class for Dragon theme
 */
@Directive()
export abstract class ISPFieldWrapperBase<
  T extends ISPFieldType = ISPFieldType,
> extends FieldWrapper<ISPFieldConfig<T>> {
  get key(): string {
    return super.key as string;
  }

  get options(): ISPFormOptions {
    return super.options as ISPFormOptions;
  }

  get formState(): ISPFormState {
    return super.formState as ISPFormState;
  }
}
